$(".autoplay").slick({slidesToShow:1,slidesToScroll:1,autoplay:!0,autoplaySpeed:2e3, prevArrow: $('.slider-btn--left'), nextArrow: $('.slider-btn--right')});